
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree9a2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree9a2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8FnLx", function(module, exports) {
const $01a0d922e623affe$var$mobileMenuOverlay = document.querySelector(".overlay");
const $01a0d922e623affe$var$hamburgerBtn = document.querySelector(".button-hamburger");
const $01a0d922e623affe$var$mobileMenu = document.querySelector(".mobile-menu-container");
const $01a0d922e623affe$var$mobileMenuBackBtn = $01a0d922e623affe$var$mobileMenu.querySelector(".mobile-menu-back-btn");
const $01a0d922e623affe$var$mobileNavMenu = $01a0d922e623affe$var$mobileMenu.querySelector(".mobile-nav-menu");
const $01a0d922e623affe$var$slideMenu = $01a0d922e623affe$var$mobileMenu.querySelector(".mobile-nav-menu-list");
const $01a0d922e623affe$var$body = document.querySelector("body");
let $01a0d922e623affe$var$activeSubmenu;
function $01a0d922e623affe$var$classListToggler(element, className) {
    element.classList.toggle(className);
}
function $01a0d922e623affe$var$toggleMobileMenu(element) {
    const currentState = element.getAttribute("data-state");
    if (!currentState || currentState === "closed") $01a0d922e623affe$var$openModal();
    else $01a0d922e623affe$var$closeModal();
}
function $01a0d922e623affe$var$openModal() {
    $01a0d922e623affe$var$addClassAndListener();
}
function $01a0d922e623affe$var$closeModal() {
    $01a0d922e623affe$var$removeClassAndListener();
}
function $01a0d922e623affe$var$onOverlayClick(e) {
    if (e.currentTarget === e.target) $01a0d922e623affe$var$closeModal();
}
function $01a0d922e623affe$var$onEscPress(e) {
    if (e.code === "Escape") $01a0d922e623affe$var$closeModal();
}
function $01a0d922e623affe$var$openSlideSubmenu(e) {
    $01a0d922e623affe$var$activeSubmenu = e.target.closest(".mobile-nav-menu-item");
    if (!$01a0d922e623affe$var$activeSubmenu) return;
    $01a0d922e623affe$var$activeSubmenu.classList.add("active");
    $01a0d922e623affe$var$mobileMenuBackBtn.classList.add("active");
}
function $01a0d922e623affe$var$closeSlideSubmenu() {
    if (!$01a0d922e623affe$var$activeSubmenu) return;
    $01a0d922e623affe$var$activeSubmenu.classList.remove("active");
    $01a0d922e623affe$var$mobileMenuBackBtn.classList.remove("active");
}
$01a0d922e623affe$var$hamburgerBtn.addEventListener("click", ()=>{
    $01a0d922e623affe$var$toggleMobileMenu($01a0d922e623affe$var$hamburgerBtn);
});
function $01a0d922e623affe$var$addClassAndListener() {
    $01a0d922e623affe$var$mobileMenuOverlay.classList.add("active");
    $01a0d922e623affe$var$mobileMenu.classList.add("active");
    $01a0d922e623affe$var$body.classList.add("no-scroll");
    $01a0d922e623affe$var$classListToggler($01a0d922e623affe$var$hamburgerBtn, "active");
    $01a0d922e623affe$var$hamburgerBtn.setAttribute("data-state", "opened");
    $01a0d922e623affe$var$hamburgerBtn.setAttribute("aria-expanded", "true");
    $01a0d922e623affe$var$mobileMenuOverlay.addEventListener("click", $01a0d922e623affe$var$onOverlayClick);
    document.addEventListener("keydown", $01a0d922e623affe$var$onEscPress);
    $01a0d922e623affe$var$slideMenu.addEventListener("click", $01a0d922e623affe$var$openSlideSubmenu);
    $01a0d922e623affe$var$mobileMenuBackBtn.addEventListener("click", $01a0d922e623affe$var$closeSlideSubmenu);
    $01a0d922e623affe$var$mobileNavMenu.style.height = $01a0d922e623affe$var$mobileNavMenu.scrollHeight + "px";
}
function $01a0d922e623affe$var$removeClassAndListener() {
    $01a0d922e623affe$var$mobileMenuOverlay.classList.remove("active");
    $01a0d922e623affe$var$mobileMenu.classList.remove("active");
    $01a0d922e623affe$var$body.classList.remove("no-scroll");
    $01a0d922e623affe$var$classListToggler($01a0d922e623affe$var$hamburgerBtn, "active");
    $01a0d922e623affe$var$hamburgerBtn.setAttribute("data-state", "closed");
    $01a0d922e623affe$var$hamburgerBtn.setAttribute("aria-expanded", "false");
    $01a0d922e623affe$var$mobileMenuOverlay.removeEventListener("click", $01a0d922e623affe$var$onOverlayClick);
    document.removeEventListener("keydown", $01a0d922e623affe$var$onEscPress);
    $01a0d922e623affe$var$closeSlideSubmenu();
    $01a0d922e623affe$var$slideMenu.removeEventListener("click", $01a0d922e623affe$var$openSlideSubmenu);
    $01a0d922e623affe$var$mobileMenuBackBtn.removeEventListener("click", $01a0d922e623affe$var$closeSlideSubmenu);
}

});

parcelRegister("g8iFC", function(module, exports) {
const $bbebe033ec54e436$var$collapsibleMenu = document.querySelectorAll('.footer-menu');
$bbebe033ec54e436$var$collapsibleMenu.forEach((collapsibleSubMenu)=>{
    collapsibleSubMenu.addEventListener('click', (e)=>{
        const activeMenu = e.target.closest('.footer-menu-item');
        if (!activeMenu) return;
        $bbebe033ec54e436$var$toggleCollapsibleMenu(activeMenu);
    });
});
function $bbebe033ec54e436$var$toggleCollapsibleMenu(menuToActivate) {
    const activeMenu = menuToActivate.querySelector('.footer-menu-submenu-wrapper');
    menuToActivate.classList.toggle('active');
    if (activeMenu.style.maxHeight) activeMenu.style.maxHeight = null;
    else activeMenu.style.maxHeight = activeMenu.scrollHeight + 'px';
}

});

parcelRegister("h0Nss", function(module, exports) {
const $c628cd15aa7989e3$var$overlay = document.querySelector('.overlay');
const $c628cd15aa7989e3$var$headerMenuItemServices = document.querySelector('.header-nav-menu-item-services');
const $c628cd15aa7989e3$var$headerMenuContainerServices = $c628cd15aa7989e3$var$headerMenuItemServices.querySelector('.header-menu-container-services');
const $c628cd15aa7989e3$var$headerMenuItemAboutUs = document.querySelector('.header-nav-menu-item-about-us');
const $c628cd15aa7989e3$var$headerMenuContainerAboutUs = $c628cd15aa7989e3$var$headerMenuItemAboutUs.querySelector('.header-menu-container-about-us');
const $c628cd15aa7989e3$var$headerNavMenuButtons = document.querySelectorAll('.header-nav-menu-btn');
const $c628cd15aa7989e3$var$headerNavMenuIcons = document.querySelectorAll('.header-nav-menu-icon');
$c628cd15aa7989e3$var$headerMenuItemServices.addEventListener('mouseenter', ()=>{
    $c628cd15aa7989e3$var$headerMenuItemServices.addEventListener('mouseleave', ()=>{
        $c628cd15aa7989e3$var$removeClassAndListener($c628cd15aa7989e3$var$headerMenuContainerServices);
    });
    $c628cd15aa7989e3$var$addClassAndListener($c628cd15aa7989e3$var$headerMenuContainerServices);
});
$c628cd15aa7989e3$var$headerMenuItemAboutUs.addEventListener('mouseenter', ()=>{
    $c628cd15aa7989e3$var$headerMenuItemAboutUs.addEventListener('mouseleave', ()=>{
        $c628cd15aa7989e3$var$removeClassAndListener($c628cd15aa7989e3$var$headerMenuContainerAboutUs);
    });
    $c628cd15aa7989e3$var$addClassAndListener($c628cd15aa7989e3$var$headerMenuContainerAboutUs);
});
function $c628cd15aa7989e3$var$addClassAndListener(activeHeaderMenuContainer) {
    $c628cd15aa7989e3$var$overlay.classList.add('active');
    activeHeaderMenuContainer.classList.add('active');
}
function $c628cd15aa7989e3$var$removeClassAndListener(activeHeaderMenuContainer) {
    $c628cd15aa7989e3$var$overlay.classList.remove('active');
    activeHeaderMenuContainer.classList.remove('active');
}

});

parcelRegister("igi9M", function(module, exports) {
window.addEventListener("scroll", $d4b7ce2b091a7d58$var$onScrollEvent);
function $d4b7ce2b091a7d58$var$onScrollEvent() {
    const scroll = this.scrollY;
    if (scroll > 10) document.querySelector(".header").classList.add("shadow");
    else document.querySelector(".header").classList.remove("shadow");
}

});

parcelRegister("kvw7v", function(module, exports) {
(()=>{
    const languageTogglerButton = document.querySelectorAll("[data-btn='language']");
    languageTogglerButton.forEach((button)=>{
        if (window.location.pathname === "/") {
            const newPathName = "en";
            button.attributes.href.value = newPathName;
        } else if (window.location.pathname.includes("/en/")) {
            const newPathName = window.location.pathname.replace("/en/", "/");
            button.attributes.href.value = newPathName;
        // } else if (window.location.pathname.includes("/en")) {
        // 	const newPathName = window.location.pathname.replace("/en", "/");
        // 	button.attributes.href.value = newPathName;
        } else {
            const newPathName = `/en${window.location.pathname}`;
            button.attributes.href.value = newPathName;
        }
    });
})();

});

parcelRequire("8FnLx");
parcelRequire("g8iFC");
parcelRequire("h0Nss");
parcelRequire("igi9M");
parcelRequire("kvw7v");


//# sourceMappingURL=to-insurance-companies.8edc1702.js.map
